<template>
    <div class="h-full flex flex-col">
        <!-- Cards Grid -->
        <div v-if="isLoading" class="flex-1 overflow-y-auto">
            <SkeletonAIInfluencerCards />
        </div>
        <div v-else class="flex-1 overflow-y-auto">
            <div v-if="creators.length === 0" class="flex items-center justify-center h-64 text-gray-500">
                <div class="text-center">
                    <p class="text-lg font-medium">No creators found</p>
                    <p class="text-sm">Try adjusting your search criteria</p>
                </div>
            </div>

            <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 pb-4">
                <CreatorCard
                    v-for="creator in creators"
                    :key="creator._id || creator.id"
                    :creator="creator"
                />
            </div>
        </div>

        <div class="border-t border-gray-200 px-4 py-3 text-sm text-gray-600">
            <DiscoveryPagination
                :paging="paging"
                :hide-record-name="true"
                @paging-changed="onPagingChange"
            />
        </div>
    </div>
</template>

<script>
import DiscoveryPagination from '@/partials/tables/discovery/DiscoveryPagination.vue'
import SkeletonAIInfluencerCards from '@/partials/skeletons/SkeletonAIInfluencerCards.vue'
import CreatorCard from './CreatorCard.vue'

export default {
    name: 'CreatorCardsView',
    components: {
        CreatorCard,
        DiscoveryPagination,
        SkeletonAIInfluencerCards,
    },
    props: {
        creators: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        paging: {
            type: Object,
            required: true,
        },
    },
    emits: ['paging-change'],
    methods: {
        getRelevanceScore(creator) {
            return creator.reasoning?.relevance_score ||
                   creator.relevance_score ||
                   creator.ai_analysis?.relevance_score ||
                   creator.match_score ||
                   0
        },
        onPagingChange(newPagingProperties) {
            this.$emit('paging-change', newPagingProperties)
            this.scrollTableToTop()
        },
    },
}
</script>